var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.href && _vm.text && _vm.className)?_c('BaseLink',{staticClass:"product-label",class:[_vm.className ].concat( _vm.getBemModifiers()),attrs:{"href":_vm.href,"text":_vm.text}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }